<script>
import { defineComponent } from 'vue'
import TwContainer from '@/components/generic/tw-container.vue'
import FundraisersIndexPage from '@/pages/fundraisers/fundraisers-index/FundraisersIndexPage.vue'
import axios from 'axios'
import TwImg from '@/components/images/tw-img.vue'
import { useOrganizationStore } from '@/stores/organization.js'
import TwButton from '@/components/generic/tw-button.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwCard from '@/components/generic/tw-card.vue'
import { useFundraiserStore } from '@/stores/fundraiser.js'
export default defineComponent({
  name: 'WebConnexIntegrationPage',
  components: { TwCard, TwLoadingSpinner, TwButton, TwImg, FundraisersIndexPage, TwContainer },
  mixins:[loggedInUserMixin],
  data() {
    return {
      RedPodiumPageId: null,
      RedPodiumPage: null,
      RedPodiumAccountId: null,
      LoadingFetchingRedPodiumPage: false,
      LoadingFundraiserSelectedProcess: false,
      LoadingFetchingOrganizationWebConnexApiKeys: false,
      ParentOrigin: null,
      WebConnexApiKeys: null,
    }
  },
  computed:{
    hasWebConnexApiKey() {
      return !!(this.WebConnexApiKeys && this.WebConnexApiKeys.length > 0)
    }
  },
  created() {
    const params = new URLSearchParams(window.location.search)
    this.RedPodiumAccountId = params.get('account_id')
    this.RedPodiumPageId = params.get('form_id')
    this.ParentOrigin = this.computeParentOrigin(params) || '*'
    this.fetchFormFromWebConnex()
    console.log('Window Opener From RedPodium',window.opener)

  },
  mounted() {
    this.fetchOrganizationWebConnexApiKeys()
  },
  methods: {
    computeParentOrigin(params) {
      // 1) Prefer explicit ?parent_origin=https://app.example.com if present
      const explicit = params.get('parent_origin')
      if (explicit) {
        try { return new URL(explicit).origin } catch (e) { /* ignore */ }
      }
      // 2) Fallback to document.referrer
      try {
        if (document.referrer) {
          return new URL(document.referrer).origin
        }
      } catch (e) { /* ignore */ }
      // 3) Last resort: let opener validate us via event.origin
      return null
    },

    async fetchOrganizationWebConnexApiKeys() {
      // we assume the fundraiser beneficiary is an organization for now, in the future we may want to support user beneficiaries as well
      if(!this.loggedInUser || !this.loggedInUser.organization) {
        this.$notify('You must be part of an organization to connect to RedPodium', 'error')
        return
      }
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingOrganizationWebConnexApiKeys = true
        this.WebConnexApiKeys = await useOrganizationStore().fetchWebconnexApiKeys(this.loggedInUser.organization.id)
        this.LoadingFetchingOrganizationWebConnexApiKeys = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingOrganizationWebConnexApiKeys = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async fetchFormFromWebConnex() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingRedPodiumPage = true
        const { data } = await axios.get('/api/v1/integrations/webconnex/form', {
          params: {
            account_id: this.RedPodiumAccountId,
            form_id: this.RedPodiumPageId
          }
        })
        this.RedPodiumPage = data
        this.LoadingFetchingRedPodiumPage = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingRedPodiumPage = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async selectedFundraiser(fundraiser) {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFundraiserSelectedProcess = true
        await useFundraiserStore().createWebConnexIntegration(fundraiser.id, {
          account_id: this.RedPodiumAccountId,
          form_id: this.RedPodiumPageId,
        })
        this.LoadingFundraiserSelectedProcess = false
        window.opener.postMessage(fundraiser.id, this.ParentOrigin)
        window.close()
      } catch (e) {
        console.error(e)
        this.LoadingFundraiserSelectedProcess = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }

    }
  },
})
</script>

<template>
  <tw-container>
    <div v-if="!Loading && hasWebConnexApiKey">
      <h2>
        Please select Campaign to connect to RedPodium page:
        <span v-if="RedPodiumPage" class="text-red-600">
          <tw-img class="inline" src="https://cdn.prod.website-files.com/64d3334ea8639e5761cf92ae/64d4130bbb348f0c9b79b6b0_favicon.png" />
          {{ RedPodiumPage.name }} </span>
      </h2>
      <tw-loading-spinner v-if="LoadingFetchingRedPodiumPage" />
      <fundraisers-index-page v-if="RedPodiumPage && !LoadingFetchingRedPodiumPage" :selector-loading="LoadingFundraiserSelectedProcess" selector-mode @update:model-value="selectedFundraiser" />
      <tw-card v-if="!LoadingFetchingRedPodiumPage && !RedPodiumPage" class="bg-red-50">
        <div class="text-center text-red-900 text-xl p-4">
          Unable to fetch RedPodium page information. Please ensure the page ID and account ID are correct.
        </div>
      </tw-card>
    </div>
    <div v-else-if="!LoadingFetchingOrganizationWebConnexApiKeys && !hasWebConnexApiKey" class="text-center">
      <h2 class="mb-4">
        No WebConnex API Key found
      </h2>
      <p class="mb-4">
        Please add a WebConnex API Key to the organization that owns this fundraiser before proceeding.
      </p>
      <tw-button variant="primary" href="/integrations/webconnex/oauth">
        Connect To RedPodium Account
      </tw-button>
    </div>
  </tw-container>
</template>

<style scoped>

</style>
